import { useState, useCallback } from 'react';
import profileApi from '../services/profileApi';

export const usePasswordChange = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const changePassword = useCallback(async (passwordData) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    
    try {
      await profileApi.changePassword(passwordData);
      setSuccess('Password changed successfully');
      return true;
    } catch (err) {
      setError(err.message || 'Failed to change password');
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearMessages = useCallback(() => {
    setError(null);
    setSuccess(null);
  }, []);

  return {
    changePassword,
    loading,
    error,
    success,
    clearMessages,
  };
};